import { render, staticRenderFns } from "./AccidentDocumentation.vue?vue&type=template&id=09e93590"
import script from "./AccidentDocumentation.vue?vue&type=script&lang=js"
export * from "./AccidentDocumentation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports